export const DONATION_SHARE = 0.4;
export const INVESTMENT_SHARE = 0.6;
export const CHARITABLE_ADMIN_FEE_RATE = 0.05;

/** Split total payment per Terms §4.1: 40% charitable, 60% National Capital Project Fund. */
export function splitPaymentAmount(total) {
  const amount = Math.round(Number(total) * 100) / 100;
  if (!Number.isFinite(amount) || amount <= 0) {
    return {
      total: 0,
      donation: 0,
      investment: 0,
      charitableAdminFee: 0,
      netCharitable: 0,
    };
  }
  const donation = Math.round(amount * DONATION_SHARE * 100) / 100;
  const investment = Math.round((amount - donation) * 100) / 100;
  const charitableAdminFee =
    Math.round(donation * CHARITABLE_ADMIN_FEE_RATE * 100) / 100;
  const netCharitable = Math.round((donation - charitableAdminFee) * 100) / 100;
  return {
    total: amount,
    donation,
    investment,
    charitableAdminFee,
    netCharitable,
  };
}

export function charitableAdminFeeFromGross(grossCharitable) {
  return Math.round(grossCharitable * CHARITABLE_ADMIN_FEE_RATE * 100) / 100;
}

export function netCharitableFromGross(grossCharitable) {
  const fee = charitableAdminFeeFromGross(grossCharitable);
  return Math.round((grossCharitable - fee) * 100) / 100;
}
